function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "var(--n-color-border)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1335 13.5035C14.2213 13.5035 14.3039 13.4692 14.3661 13.4071L15.6729 12.0999V17.0955C15.6729 17.2768 15.8205 17.4245 16.0019 17.4245C16.1833 17.4245 16.3307 17.277 16.3307 17.0955V12.1193L17.6181 13.4071C17.6804 13.4692 17.7629 13.5034 17.8507 13.5034C17.9385 13.5034 18.0212 13.4692 18.0832 13.4071C18.2115 13.2789 18.2115 13.0701 18.0832 12.9418L16.238 11.0961C16.1766 11.0348 16.0952 11.0007 16.0089 10.9999L16.0019 10.9998C15.9969 10.9998 15.9922 10.9999 15.9912 11L15.9786 10.9998C15.8909 10.9998 15.8083 11.034 15.746 11.0961L13.9009 12.9419C13.7726 13.0702 13.7726 13.2789 13.9009 13.4071C13.963 13.4692 14.0456 13.5035 14.1335 13.5035Z",
  fill: "var(--n-color-text-dark)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6941 15.2156C21.503 15.2156 21.3475 15.3711 21.3475 15.5624V19.9648C21.3475 20.1534 21.1941 20.3068 21.0055 20.3068H10.9495C10.7608 20.3068 10.6074 20.1534 10.6074 19.9648V15.5624C10.6074 15.3712 10.452 15.2156 10.2608 15.2156C10.0696 15.2156 9.91406 15.3711 9.91406 15.5624V19.9648C9.91406 20.5357 10.3785 21.0004 10.9495 21.0004H21.0055C21.5764 21.0004 22.0409 20.5358 22.0409 19.9648V15.5624C22.0409 15.3711 21.8853 15.2156 21.6941 15.2156Z",
  fill: "var(--n-color-text-dark)"
});

function SvgIconShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.e0bc41d3545644fef5c457b621372e48.svg";
export { ForwardRef as ReactComponent };